<template>
  <div
    v-if="haveSaleDetailsProvided"
    class="row details__actions align-items-end no-gutters"
  >
    <div class="col-12 col-lg-4 col-xl-3">
      <p class="headings--h4">{{ I18n.t("artworks.starting_price_label")}}</p>
      <p v-if="artwork.startingPrice > 0">
        <span>
          {{ I18n.t("artworks.price", { price: formatPrice(artwork.startingPrice) }) }}
        </span>
        <span v-if="artwork.droitDeSuite" class="price price--plus-droit-de-suite">
          {{ I18n.t("artworks.droit_de_suite") }}
        </span>
      </p>
      <p v-else>
        <span class="price--info" v-b-tooltip.hover.topright :title="I18n.t('artworks.no_starting_price_info')"></span>
        <span v-if="artwork.droitDeSuite" class="price price--plus-droit-de-suite">
          {{ I18n.t("artworks.droit_de_suite") }}
        </span>
      </p>
    </div>
    <div v-if="artwork.estimationMin && artwork.estimationMax"
         class="col-12 col-lg-4">
      <p class="headings--h4">
        {{ I18n.t("artworks.estimation_label") }}
      </p>
      <p>
        {{ I18n.t("artworks.estimated_prices_with_currency",
        { price_min: formatPrice(artwork.estimationMin),
          price_max: formatPrice(artwork.estimationMax) }) }}
      </p>
    </div>
    <ArtworkState :artwork="artwork"/>
  </div>
  <div v-else-if="catalogUnpublished" class="row catalog-unpublished-info">
    <div>
      <span class="headings--h4"> {{ I18n.t("auctions_catalogs.waiting_for_results") }} </span>
    </div>
  </div>
  <div v-else class="row justify-content-between">
    <div class="col-12 col-lg-4 col-xl-4">
      <a href="/cennik" class="btn btn__default">
        <span> {{ I18n.t("auctions_catalogs.buy_premium") }} </span>
      </a>
    </div>
    <div class="col-12 col-lg-8 col-xl-5 pr-0 d-none d-lg-block">
      <div class="premium-info">
        <span class="headings--h4"> {{ I18n.t("auctions_catalogs.premium_info") }} </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatNumber } from '@/shared/helpers';
  import { UNPUBLISHED_CATALOG_VALUE } from '../../../consts';
  import ArtworkState from './artwork_state';

  export default {
    name: 'FinishArtworkPriceDetails',
    data() {
      return {
        formatPrice: formatNumber,
        unpublishedCatalogValue: UNPUBLISHED_CATALOG_VALUE,
      };
    },
    components: {
      ArtworkState,
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    computed: {
      haveSaleDetailsProvided() {
        return Object.prototype.hasOwnProperty.call(this.artwork, 'startingPrice') ||
          Object.prototype.hasOwnProperty.call(this.artwork, 'estimationMin') ||
          Object.prototype.hasOwnProperty.call(this.artwork, 'estimationMax');
      },
      catalogUnpublished() {
        return this.artwork.auctionsCatalog.status === this.unpublishedCatalogValue;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/finished_artwork_price_details.vue?4639aac8